// CR-20260901-001. When a min-profit / max-risk money input flips between its Normalized and
// Raw ($) meanings WITH A VALUE ALREADY TYPED, the number is converted in place so it keeps
// saying the same thing: raw = normalized × 100 × defaultQty (100 = the SPX option multiplier,
// constant), normalized = raw ÷ that factor, FLOORED (owner ruling — no fractional per-unit
// dollars). Default qty is the portfolio's value AT THE MOMENT OF THE FLIP (owner ruling).
//
// GUI convenience only — the mode flag and the wire shape are untouched; the engines keep
// normalizing exactly as before (OpgRunNormalizer / the Adjust mapper).
//
// Returns the input unchanged when there is nothing sound to convert with: an empty/NaN amount
// stays empty (no 0 injected), and a missing or non-positive default qty leaves the number
// alone rather than guessing a factor.
export function convertOnNormalizedModeFlip(
    amount: number | null,
    toNormalized: boolean,
    defaultQty: number | null | undefined
): number | null {
    if (amount == null || !isFinite(amount)) {
        return amount;
    }
    if (defaultQty == null || !isFinite(defaultQty) || defaultQty <= 0) {
        return amount;
    }
    const factor = 100 * defaultQty;
    return toNormalized ? Math.floor(amount / factor) : amount * factor;
}
